import Vue from 'vue';
class SimpleHashRouter {
  lastPathName = location.pathname;
  lastSearch = location.search;
  lastHash = location.hash;
  nextHash = '';

  get nextUrl() {
    return this.lastPathName + this.lastSearch + this.nextHash;
  }

  push(hash) {
    this.lastPathName = location.pathname;
    this.lastSearch = location.search;
    this.lastHash = location.hash;
    if(hash) {
      this.nextHash = '#' + hash.replace(/^#/, '');
    }
    history.replaceState(null, '', this.nextUrl);
    return this.nextHash;
  }
  pop() {
    this.nextHash = this.lastHash;
    history.replaceState(null, '', this.nextUrl);
    return this.nextHash;
  }
}

const hashRouter = new SimpleHashRouter();

export class ServiceConfirm {
  confirmComponent = null;
  confirmOpt = null;
  name = '';
  node = null;

  constructor(confirmOpt) {
    this.name = confirmOpt.name || `dialog-${Date.now()}`;
    this.confirmOpt = confirmOpt;
  }
  closeConfirm() {
    if(this.confirmComponent?.visible) {
      if(location.hash === this.hashName) {
        hashRouter.pop();
      }
      this.confirmComponent.visible = false;
      document.body.removeChild(this.node);
    }
  }
  async confirm(data = {}) {
    if(!Vue.__rootApp__ || !this.confirmOpt) {
      return Promise.reject();
    }
    if(!this.confirmComponent) {
      const ConfirmClass = Vue.extend({
        ...this.confirmOpt,
        mixins: [ ...this.confirmOpt.mixins, Vue.__rootApp__.$options ],
      });
      this.confirmComponent = new ConfirmClass({
        el: document.createElement('div'),
      });
    }
    this.hashName = hashRouter.push(this.name);
    return new Promise((resolve, reject) => {
      this.node = document.body.appendChild(this.confirmComponent.$el);
      const _handleSure = this.confirmComponent.handleSure.bind(this.confirmComponent);
      const _handleCancel = this.confirmComponent.handleCancel.bind(this.confirmComponent);
      Object.keys(data).forEach(key => {
        this.confirmComponent[key] = data[key];
      });
      this.confirmComponent.handleOpen();
      this.confirmComponent.visible = true;

      this.confirmComponent.handleSure = async args => {

        await _handleSure(args);
        resolve(args);
        this.closeConfirm();
      }
      this.confirmComponent.handleCancel = async args => {
        await _handleCancel(args);
        reject(args);
        this.closeConfirm();
      }
    });
  }
  destroy() {
    if (this.confirmComponent) {
      this.closeConfirm()
      this.confirmComponent.$destroy?.()
      this.confirmComponent = null
    }
    this.node = null
  }
}

export const ConfirmComponent = {
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    handleOpen() {},
    handleSure() {},
    handleCancel() {},
  },
};
